export enum Plans {
  TRIAL = 'trial',
  CORE = 'core',
  FREE = 'free',
  STARTER = 'starter',
  ACCELERATE = 'accelerate',
  ON_HOLD = 'on-hold',
  ACCELERATE_ONE_USER = 'accelerate-1-user',
  ACCELERATE_TWO_USER = 'accelerate-2-user',
  ACCELERATE_THREE_USER = 'accelerate-3-user',
  ACCELERATE_ONE_USER_3M = 'accelerate-1-user-3m',
  ACCELERATE_TWO_USER_3M = 'accelerate-2-user-3m',
  ACCELERATE_THREE_USER_3M = 'accelerate-3-user-3m',
  ACCELERATE_ONE_USER_YR = 'accelerate-1-user-yr',
  ACCELERATE_TWO_USER_YR = 'accelerate-2-user-yr',
  ACCELERATE_THREE_USER_YR = 'accelerate-3-user-yr',
}
